import { IconName } from '@sg/garnish';

import {
  PaymentMethod,
  PaymentMethodType,
} from '../machine/scan-to-pay.machine.types';

export const PAYMENT_METHOD_ICON_MAP = {
  [PaymentMethodType.Visa]: 'IconCcVisa',
  [PaymentMethodType.AmericanExpress]: 'IconCcAmex',
  [PaymentMethodType.Amex]: 'IconCcAmex',
  [PaymentMethodType.Discover]: 'IconCcDiscover',
  [PaymentMethodType.MasterCard]: 'IconCcMasterCard',
  [PaymentMethodType.Unsupported]: 'IconCreditCard',
} satisfies Record<PaymentMethodType, IconName>;

export const getDefaultPaymentMethodId = (
  paymentMethods: readonly PaymentMethod[],
) => {
  return (
    paymentMethods.find((pm) => pm.isDefault)?.id ?? paymentMethods[0]?.id ?? ''
  );
};
